import { Injectable } from "@angular/core";
import { SUPPORT_LANGUAGE } from "@core/constant";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

const LANG_STORAGE_KEY = 'becentral_lang';

@Injectable({
    providedIn: 'root'
})
export class CoreTranslatingService {

    private _currentLang: string = "en";

    constructor(private _translateService: TranslateService) {
        _translateService.addLangs(this.languageOptions.map(x => x.value));
        _translateService.setDefaultLang('en');
        _translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            const { lang } = event;
            localStorage.setItem(LANG_STORAGE_KEY, lang);
            this._currentLang = lang;
        });
        const savedLang = localStorage.getItem(LANG_STORAGE_KEY);
        const langToUse = savedLang && _translateService.langs.includes(savedLang) ? savedLang : 'en';
        this._currentLang = langToUse;
        _translateService.use(langToUse);
    }

    get translateService() {
        return this._translateService;
    }

    get currentLang(): string {
        return this._currentLang;
    }

    get languageOptions() {
        return SUPPORT_LANGUAGE;
    }

    public switchLanguage(language: string): void {
        this._translateService.use(language);
        localStorage.setItem(LANG_STORAGE_KEY, language);
        this._currentLang = language;
    }

    public useLanguage(language: string): void {
        this.switchLanguage(language);
    }

    public setLanguage(language: string, translation: any): void {
        this._translateService.setTranslation(language, translation, true);
    }

    public getTranslation(key: string): Observable<string> {
        return this._translateService.get(key);
    }

    public preserveLangAcrossClear(): void {
        const lang = localStorage.getItem(LANG_STORAGE_KEY);
        localStorage.clear();
        if (lang) {
            localStorage.setItem(LANG_STORAGE_KEY, lang);
        }
    }

}
